module.exports = __webpack_public_path__ + "images/marketing/features/email-summary.png";